var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{on:{"change":_vm.update}},_vm._l((Object.keys(_vm.languages)),function(key){return _c('option',{key:key,domProps:{"value":key,"selected":key === _vm.selected}},[_vm._v(_vm._s(_vm.languages[key]))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }